import { forwardRef } from 'react';
import React from 'react';
import { Input } from './Input';
export const OtpInput = forwardRef(({ index, value, disabled, hasError, handleOtpChange, handleKeyDown, handlePaste }, ref) => {
    return (React.createElement(Input, { ref: ref, id: `otp-${index}`, value: value, type: 'tel', inputMode: 'numeric', pattern: '[0-9]*', onChange: e => handleOtpChange(e.target, index), onKeyDown: e => handleKeyDown(e, index), onPaste: handlePaste, disabled: disabled, className: 'cb-otp-input', autoFocus: index === 0, hasError: hasError }));
});
